import { axiosJSONInstance } from '@/config';
import { CapitalSummaryResponse } from '@/types';

// Boxy Capital — merchant advance summary (schedule + coverage + lock state).
export const fetchCapitalSummary = async (): Promise<CapitalSummaryResponse> => {
  const response = await axiosJSONInstance.get('/merchants/capital/summary');
  return response.data;
};

// §10.5 statement export — CSV blob of the full advance ledger.
export const fetchCapitalStatement = async (): Promise<Blob> => {
  const response = await axiosJSONInstance.get('/merchants/capital/statement', {
    responseType: 'blob',
  });
  return response.data;
};
